export default function getQSetRunningNumber(qSetCode: string) {
  return qSetCode.split('-').slice(-1)[0];
}
